import OsanoConsentObject from '@alltrails/types/OsanoConsentObject';
import type CurrencyCode from '@alltrails/types/CurrencyCode';
import type AuthenticationType from '@alltrails/amplitude/enums/AuthenticationType';

// FB Pixel

export const getFacebookConsentValue = (osanoConsentObject: OsanoConsentObject) => {
  return osanoConsentObject.MARKETING === 'ACCEPT' ? 'grant' : 'revoke';
};

export const setFacebookConsent = (osanoConsentObject: OsanoConsentObject) => {
  if (isFacebookPixelUnavailable()) {
    return;
  }

  fbq('consent', getFacebookConsentValue(osanoConsentObject));
};

// https://developers.facebook.com/docs/meta-pixel/reference#:~:text=PAGE_VIEW-,Purchase,-When%20a%20purchase
export const trackPurchaseForFacebook = ({
  shouldReInitializePixel,
  userId,
  emailSha256,
  currencyCode,
  price,
  subscription_event_id,
  recurlyPlanCode
}: {
  shouldReInitializePixel: boolean;
  userId: number;
  emailSha256: string | null;
  currencyCode: CurrencyCode;
  price: number;
  subscription_event_id?: number;
  recurlyPlanCode: string;
}) => {
  if (isFacebookPixelUnavailable()) {
    return;
  }

  if (shouldReInitializePixel) {
    initFacebookPixel(userId, emailSha256);
  }

  fbq(
    'track',
    'Purchase',
    {
      currency: currencyCode,
      value: price,
      content_type: 'product',
      content_ids: [recurlyPlanCode]
    },
    { eventID: subscription_event_id?.toString() }
  );
};

// https://developers.facebook.com/docs/meta-pixel/reference#:~:text=ADD_TO_WISHLIST-,CompleteRegistration,-When%20a%20registration
export const trackCompleteRegistrationForFacebook = (userId: number, emailSha256: string | null, authType: AuthenticationType) => {
  if (isFacebookPixelUnavailable()) {
    return;
  }

  initFacebookPixel(userId, emailSha256);
  fbq('track', 'CompleteRegistration', { content_name: `signup - ${authType}` }, { eventID: `reg_${userId}` });
};

// Private

const initFacebookPixel = (userId: number, emailSha256: string | null) => {
  fbq('init', process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID, {
    external_id: userId,
    ...(emailSha256 && { em: emailSha256 })
  });
};

// Check for presence of fbq in case of content blockers
const isFacebookPixelUnavailable = () => {
  return typeof fbq === 'undefined';
};
